import { render, staticRenderFns } from "./NirAmendmentsEscalations.vue?vue&type=template&id=028b8084&scoped=true&"
import script from "./NirAmendmentsEscalations.vue?vue&type=script&lang=js&"
export * from "./NirAmendmentsEscalations.vue?vue&type=script&lang=js&"
import style0 from "./NirAmendmentsEscalations.vue?vue&type=style&index=0&id=028b8084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b8084",
  null
  
)

export default component.exports